
import Tooltips from './tooltips';
import Toast from './toast';



export default {
  Tooltips,
  Toast,
}



/** WEBPACK FOOTER **
 ** ./src/plugins/index.js
 **/